/**
 * Tiny upload widgets shared by Admissions.jsx and StudentEdit.jsx.
 * - PhotoSlot: 12x12 thumbnail + replace button
 * - DocSlot:   single-line upload zone for documents
 */
import React from "react";
import { CloudArrowUp, CheckCircle, User } from "@phosphor-icons/react";

export function PhotoSlot({ label, testId, path, onSelect }) {
  return (
    <div>
      <div className="text-xs font-medium mb-1.5">{label}</div>
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-md border border-[var(--vs-border)] bg-[var(--vs-bg-subtle)] grid place-items-center flex-shrink-0">
          {path ? <CheckCircle size={20} weight="fill" className="text-[var(--vs-success)]" /> : <User size={18} weight="thin" className="text-[var(--vs-text-secondary)]" />}
        </div>
        <label className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-2 rounded-md border-2 border-dashed border-[var(--vs-border-focus)]/40 hover:border-[var(--vs-secondary)] cursor-pointer text-xs transition-colors">
          <CloudArrowUp size={14} weight="duotone" /> {path ? "Replace" : "Upload"}
          <input data-testid={testId} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => onSelect(e.target.files?.[0])} />
        </label>
      </div>
    </div>
  );
}

export function DocSlot({ label, testId, onSelect }) {
  return (
    <div>
      <div className="text-xs font-medium mb-1.5">{label}</div>
      <label className="flex items-center justify-center gap-2 px-3 py-2 rounded-md border-2 border-dashed border-[var(--vs-border-focus)]/40 hover:border-[var(--vs-secondary)] cursor-pointer text-xs transition-colors">
        <CloudArrowUp size={14} weight="duotone" /> PDF or JPG/PNG
        <input data-testid={testId} type="file" accept="application/pdf,image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => onSelect(e.target.files?.[0])} />
      </label>
    </div>
  );
}
